import React from 'react'
import Landing from '../routes/landings/Bedroom'

const Kitchen = () => {
  return <Landing />
}

export default Kitchen
